import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { DocumentViewer } from '@/modules/documents/components/document-viewer/DocumentViewer';
import { useDocumentFile } from '@/modules/documents/hooks/useDocumentFile';

export const Route = createFileRoute('/docs/$publicId')({
  params: z.object({
    publicId: z.string(),
  }),
  component: function DocumentFile() {
    const { publicId } = Route.useParams();

    const { objectUrl, contentType, filename, isLoading, error } =
      useDocumentFile(publicId);

    if (isLoading) {
      return (
        <div className="flex h-screen items-center justify-center">
          <p className="text-neutral-500">Carregando documento...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="flex h-screen items-center justify-center">
          <p className="text-red-600">Erro ao carregar o documento</p>
        </div>
      );
    }

    if (!objectUrl) {
      return null;
    }

    return (
      <div className="flex h-screen w-screen items-center justify-center bg-neutral-50">
        <DocumentViewer
          objectUrl={objectUrl}
          contentType={contentType}
          filename={filename}
          fullscreen
        />
      </div>
    );
  },
});
